import { ChangeEvent } from 'react';
import {
  RootDiv,
  HorizontalLineFull,
  LocalTitleText,
  SelectPayment,
  SelectPaymentOption,
} from '../styles/LocalPaymentOptions.styles';
import { PaymentMethod } from '@interfaces';
import { PaymentMethods } from './PaymentMethods';
import { TransferDivComponent } from './TransferDiv';
import {
  useLocalPaymentOption,
  useLocalPaymentOptionsActions,
} from '../zustand/localPaymentOptionsStore';
import { LocalPaymentOptionsTypes } from '../zustand/interfaces';

interface Props {
  changePaymentAmount: (event: ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
  handleSelect: (e: unknown, paymentMethod: PaymentMethod) => void;
}

export function AssistantPaymentOptions(props: Props) {
  const { loading, handleSelect } = props;

  const { paymentOption } = useLocalPaymentOption();
  const { setPaymentOption } = useLocalPaymentOptionsActions();

  const handleOnChange = (item: string) => {
    setPaymentOption(item as LocalPaymentOptionsTypes);
  };

  return (
    <RootDiv>
      <LocalTitleText>Métodos de pago</LocalTitleText>
      <HorizontalLineFull />
      <SelectPayment
        placeholder="Selecciona una opción"
        onChange={(item) => handleOnChange(item.target.value)}
        value={paymentOption}
      >
        <SelectPaymentOption hidden value={null}>
          Selecciona una opción
        </SelectPaymentOption>
        <SelectPaymentOption value="CARD">Tarjeta</SelectPaymentOption>
        <SelectPaymentOption value="TRANSFER">
          Transferencia
        </SelectPaymentOption>
      </SelectPayment>
      {paymentOption === 'TRANSFER' && <TransferDivComponent />}
      {paymentOption === 'CARD' && (
        <PaymentMethods loading={loading} handleSelect={handleSelect} />
      )}
    </RootDiv>
  );
}
